import { genUniqueId } from '../../../../../common/utils/genUniqueId'
import { BLOCK_SCHEMA_DICTIONARY } from '../Blocks/BlockSettings'
import { SUPPORTED_REMIX_BLOCKS } from '../constants.js'
import Normalizer from './normalizer.js'
import DataSchema from './schema.js'

/**
 * Вернуть нормализованные данные для блока
 */
export function createBlockData(blockType, data) {
    blockType = parseInt(blockType)

    return {
        ...data,
        id: genUniqueId(),
        t: blockType,
    }
}

/**
 *
 * @param {*} blocks
 */
export function filterBlocks(blocks = []) {
    return blocks.filter(b => SUPPORTED_REMIX_BLOCKS.includes(b.t))
}

export function normalizeBlocks(blocks = []) {
    return blocks.map(b => normalizeBlock(b))
}

export function normalizeBlock(b) {
    for (const p in b) {
        if (Array.isArray(b[p])) {
            const pSchema = BLOCK_SCHEMA_DICTIONARY[`${b.t}.${p}`]
            if (pSchema) {
                // Если задана схема типа propName.subProp для массива, то нормализуем по ней все элементы массива
                const pNorm = new Normalizer(new DataSchema(pSchema))
                b[p] = b[p].map(e => pNorm.process(e))
            }
        }
    }
    const s = BLOCK_SCHEMA_DICTIONARY[b.t]
    const n = new Normalizer(new DataSchema(s))
    return n.process(b)
}

export function getInfo(blocks, blockId) {
    const block = blocks.find(b => b.id === blockId),
        index = blocks.indexOf(block)
    return {
        block,
        index,
    }
}
